import { DescriptionBlock } from '../DescriptionBlock'
import { Container } from './styles'

export function SectionCoworking() {
  return (
    <Container>
      <div>
        <DescriptionBlock
          bgColor="#E4947A"
          text="Um ambiente tranquilo e funcional para você ter mais qualidade de vida no trabalho."
        />
      </div>
    </Container>
  )
}
